import { Box, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Mousewheel, Keyboard } from "swiper";

import { nextCard, preCard, resetCard } from "../../redux/slices/CardSlices";
import { connect } from "react-redux";
import tick from "../../assets/icons/tick.png";
import DoneMark from "../../assets/icons/DoneMark.png";
import "./../../components/components.scss";
import { useTranslation } from "react-i18next";

const Steps = (props) => {
  const { t } = useTranslation();
  const { tab, custom, resetCard, list } = props;
  const [display, setDisplay] = useState(false);
  useEffect(() => {
    if (tab == list.length) {
      setDisplay(true);
      setTimeout(() => {
        setDisplay(false);
      }, 3000);
    }
  }, [tab]);
  const renderMark = (item) => {
    if (tab > item.id && item.stepStatus === 2) {
      return (
        <Box
          component="img"
          src={tick}
          width="15px"
          sx={{
            position: "absolute",
            left: "2px",
            top: "31px",
            cursor: "pointer",
            zIndex: 2000,
          }}
          onClick={() => {
            props.nextCard();
          }}
        />
      );
    }

    if (tab > item.id && item.stepStatus < 2) {
      return (
        <Box
          component="div"
          width="15px"
          sx={{
            position: "absolute",
            left: "8px",
            top: "23px",
            cursor: "pointer",
            zIndex: 2000,
          }}
          onClick={() => {
            props.nextCard();
          }}
        >
          <Typography fontWeight="bold" fontSize="18px">
            !
          </Typography>
        </Box>
      );
    }

    if (tab == list.length && item.stepStatus === 2) {
      return (
        <Box
          component="img"
          src={DoneMark}
          width="17px"
          sx={{
            position: "absolute",
            left: "3px",
            top: "33px",
            cursor: "pointer",
            zIndex: 2000,
          }}
        />
      );
    }
  };
  const getBackgroundColor = (item, index) => {
    if (tab >= item.id) {
      if (index === list.length - 1) {
        return "color.magentaDark1";
      } else {
        return "color.magentaLight2";
      }
    } else {
      return "color.magentaMid2";
    }
  };
  return (
    <>
      <Swiper
        cssMode={true}
        breakpoints={{
          // when window width is >= 320px
          280: {
            slidesPerView: 1,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 1,
          },
          // when window width is >= 640px

          640: {
            slidesPerView: 6,
          },
          // when window width is >= 900px
          900: {
            slidesPerView: 10,
          },
          1024: {
            slidesPerView: 12,
          },
        }}
        navigation={true}
        mousewheel={true}
        keyboard={true}
        modules={[Navigation, Mousewheel, Keyboard]}
        className="docSwiper"
      >
        <Box component="div" className="doc-steps" display="flex">
          {list.map((item, index, arr) => (
            <SwiperSlide
              className={`  "swiper-slide" ${
                tab === item.id && item.multipleSteps
                  ? "swiper-slide-with-arrow"
                  : "swiper-slide"
              }`}
              key={item.id}
            >
              <Box
                key={item.id}
                sx={{
                  position: "relative",
                  padding: "10px 0 0 0",
                }}
              >
                <Box
                  component="div"
                  display="flex"
                  sx={{
                    position: "absolute",
                    zIndex: "100000  !important ",
                    top: "-40%",
                    left: `${index !== arr.length - 1 ? "-40%" : "-120%"}`,
                    padding: "5px ",
                    width: `${index !== arr.length - 1 ? "90px" : "70px"}`,
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <Typography
                    variant="inherit"
                    fontSize="14px"
                    fontWeight="500"
                  >
                    {item.name}
                  </Typography>
                </Box>

                <Box
                  component="div"
                  marginTop={1}
                  display="flex"
                  alignItems="center"
                  justifyContent="flex-start"
                  paddingTop={1}
                >
                  {renderMark(item)}
                  <Box
                    sx={{
                      color: tab === item.id ? "#444561" : "#957ba0",
                      backgroundColor: getBackgroundColor(item, index),
                      width: "21px",
                      height: "21px",
                      borderRadius: "50%",
                      zIndex: "1000",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      custom(index + 1);
                      resetCard();
                    }}
                  />
                  {index !== arr.length - 1 && (
                    <Box
                      component="div"
                      width="73px"
                      height="10px"
                      marginLeft="-2px"
                      sx={{ backgroundColor: "color.magentaMid2" }}
                    />
                  )}
                </Box>
              </Box>
            </SwiperSlide>
          ))}
        </Box>
      </Swiper>
      {display && (
        <Box
          component="div"
          position="absolute"
          backgroundColor="color.magentaLight2"
          width="280px"
          zIndex="9999"
          borderRadius="10px"
          padding="1.5rem"
          boxShadow={3}
          right="50px"
          top="195px"
        >
          <Typography>{t("overview-message")}</Typography>
        </Box>
      )}
    </>
  );
};

function mapStateToProps(state) {
  return {
    currentCard: state.currentCard.currentCard,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    nextCard: () => dispatch(nextCard()),
    preCard: () => dispatch(preCard()),
    resetCard: () => dispatch(resetCard()),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Steps);
